<template>
<div class="container mx-auto px-4">
    <div class="mb-4 mt-5">
        <div v-if="ifExterno==0" class="mt-5">
            <h4>Seleccione el período para el reporte</h4>
            <small class="block mb-2">Buscar periodo:</small>
            <v-select :options="arrayPeriodos" :reduce="arrayPeriodos => arrayPeriodos" @input="selectedAsesor=null;verLiquidaciones();" label="periodoescolar" class="w-full" v-model="periodoSelect" />
        </div>
        <div v-if="periodoSelect" class="mt-5">
            <!-- Totales con diseño lineal y responsivo -->
            <div class="w-full">
                <ul class="list-disc pl-5 flex flex-wrap justify-center items-center mt-5">
                    <li v-for="(item, index) in totalItems" :key="index" class="total-item my-2 mr-4">
                        <span>{{ item.concept }}: <b>{{ item.amount | filtrarDecimal }}</b> </span>
                    </li>
                </ul>
            </div>
            <!-- Filtro por Asesor -->
            <div class="flex justify-center items-center my-2">
                Filtrar por asesor: <br>
                <v-select :options="asesores" @input="filterByAsesor();" :reduce="asesores => asesores.id_asesor" label="vendedor" class="w-1/2" v-model="selectedAsesor" @change="filterByAsesor" />
            </div>

            <!-- Tabla de Liquidaciones -->
            <vs-table max-items="10" pagination search :data="filteredLiquidaciones">
                <template slot="header">
                    <vs-chip color="primary">Cantidad: <b>{{ filteredLiquidaciones.length }}</b></vs-chip>
                    <vs-button color="success" class="mb-2 p-3 ml-3" @click="ExportarLiquidaciones"><i class="fa-solid fa-download"></i> Exportar</vs-button>
                </template>

                <template slot="thead">
                    <vs-th width="250">Información</vs-th>
                    <vs-th width="200">Vendedor</vs-th>
                    <vs-th>Estado</vs-th>
                    <vs-th>Venta Bruta</vs-th>
                    <vs-th>Descuento</vs-th>
                    <vs-th>Comison</vs-th>
                    <vs-th>Venta Neta</vs-th>
                    <vs-th sort-key="valor_deudaAnterior">Deuda Anterior</vs-th>
                    <vs-th sort-key="valor_convenio">Convenio</vs-th>
                    <vs-th sort-key="valor_anticipos">Anticipos</vs-th>
                    <vs-th sort-key="valor_liquidacion">Liquidaciones</vs-th>
                    <vs-th>Pagos</vs-th>
                    <vs-th>Saldo Pendiente</vs-th>
                    <vs-th v-for="n in maxVerificaciones" :key="'header-verif-' + n">Verificación {{ n }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(item, indextr) in data">
                        <vs-td>
                            <b># Pedido: </b><br>{{ item.id_pedido }}<br>
                            <b>Contrato:</b><br> {{ item.contrato_generado }}<br>
                            <b>Institución:</b><br>{{ item.nombreInstitucion }}
                        </vs-td>
                        <vs-td>{{ item.vendedor }}</vs-td>
                        <vs-td>{{ item.estadoPedido_Pagos == 4 ? 'LIQUIDADO SIN CÓDIGOS' : (item.verificaciones == 0 ? 'SIN LIQUIDAR' : 'LIQUIDADO') }}</vs-td>
                        <vs-td>{{ getVenta(item) }}</vs-td>
                        <vs-td>{{ item.descuento }} %</vs-td>
                        <vs-td>{{ getDescuento(item) }}</vs-td>
                        <vs-td>{{ getVentaNeta(item) }} </vs-td>
                        <vs-td>{{ getDeudaAnterior(item) }}</vs-td>
                        <vs-td>{{ getConvenio(item) }}</vs-td>
                        <vs-td>{{ getAnticipo(item) }}</vs-td>
                        <vs-td>{{ getLiquidaciones(item) }}</vs-td>
                        <vs-td>{{ getAnticiposConvenio(item) }}</vs-td>
                        <vs-td>{{ getSaldoPendiente(item) }}</vs-td>
                        <vs-td v-for="n in maxVerificaciones" :key="'verif-' + n + '-' + indextr">{{ getVerificacionFecha(item, n) }}</vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</div>
</template>

<script>
import PeriodoRepository from '@/repositories/PeriodoRepository'
import vSelect from 'vue-select'
import Generalmix from '@/mixins/Generalmix';

export default {
    mixins: [Generalmix],
    components: {
        vSelect,
    },
    data() {
        return {
            arrayPeriodos: [],
            ifpuntoVenta: 0,
            periodo_id: 0,
            nombrePeriodo: '',
            periodoSelect: '',
            mostrar: false,
            liquidaciones: [], // Datos originales de las liquidaciones
            selectedAsesor: null, // Asesor seleccionado para filtrar
            filteredLiquidaciones: [], // Lista filtrada por asesor
            asesores: [], // Lista de asesores extraída de las liquidaciones
            popupLiquidaciones: false,
            periodoDatos: [],
        }
    },
    props: {
        periodo: {
            type: [Array, Object],
            default: () => []
        },
        ifExterno: {
            type: Number,
            default: 0
        }
    },
    mounted() {
        let me = this
        if (me.ifExterno != 0) {
            me.periodoDatos = me.periodo;
            me.periodoSelect = me.periodoDatos;
            me.selectedAsesor = null;
            me.verLiquidaciones();

        } else {
            me.obtenerPeriodos()
            console.log("me.periodo", me.periodo);

        }
        // me.obtenerPeriodos()
    },

    computed: {
        totalVenta() {
            return this.filteredLiquidaciones.reduce((total, item) => {
                return total + parseFloat(this.getVenta(item));
            }, 0).toFixed(2);
        },

        totalVentaDescuento() {
            return this.filteredLiquidaciones.reduce((total, item) => {
                return total + parseFloat(this.getDescuento(item));
            }, 0).toFixed(2);
        },

        totalAnticiposConvenio() {
            return this.filteredLiquidaciones.reduce((total, item) => {
                return total + parseFloat(this.getAnticiposConvenio(item)) || 0;
            }, 0).toFixed(2);
        },

        totalSaldoPendiente() {
            return this.filteredLiquidaciones.reduce((total, item) => {
                return total + parseFloat(this.getSaldoPendiente(item));
            }, 0).toFixed(2);
        },

        totalConvenio() {
            return this.filteredLiquidaciones.reduce((total, item) => {
                return total + parseFloat(this.getConvenio(item));
            }, 0).toFixed(2);
        },

        totalAnticipos() {
            return this.filteredLiquidaciones.reduce((total, item) => {
                return total + parseFloat(this.getAnticipo(item));
            }, 0).toFixed(2);
        },
        totalLiquidaciones() {
            return this.filteredLiquidaciones.reduce((total, item) => {
                return total + parseFloat(this.getLiquidaciones(item));
            }, 0).toFixed(2);
        },
        totalVentaNeta() {
            return this.filteredLiquidaciones.reduce((total, item) => {
                return total + parseFloat(this.getVentaNeta(item));
            }, 0).toFixed(2);
        },
        totalItems() {
            return [{
                    concept: "Total Venta Bruta",
                    amount: this.totalVenta * 1
                },
                {
                    concept: "Total Comisiones",
                    amount: this.totalVentaDescuento * 1
                },
                {
                    concept: "Total Venta Neta",
                    amount: this.totalVentaNeta * 1
                },
                {
                    concept: "Total Convenios",
                    amount: this.totalConvenio * 1
                },
                {
                    concept: "Total Anticipos",
                    amount: this.totalAnticipos * 1
                },
                {
                    concept: "Total Liquidaciones",
                    amount: this.totalLiquidaciones * 1
                },
                {
                    concept: "Total Pagos",
                    amount: this.totalAnticiposConvenio * 1
                },
                {
                    concept: "Saldo Pendiente",
                    amount: this.totalSaldoPendiente * 1
                }
            ];
        },
        maxVerificaciones() {
            if (!this.filteredLiquidaciones || this.filteredLiquidaciones.length === 0) {
                return 0;
            }
            return Math.max(...this.filteredLiquidaciones.map(item => {
                if (item.arrayVerificaciones && Array.isArray(item.arrayVerificaciones)) {
                    return item.arrayVerificaciones.length;
                }
                return 0;
            }));
        },
    },
    methods: {
        obtenerPeriodos() {
            let me = this;
            PeriodoRepository.getPeriodos().then(p => {
                me.arrayPeriodos = p.data.filter(p => p.reporte_gerencia == 1)
            });
        },
        f_selectPeriodo() {
            let me = this
            me.mostrar = false
            me.$vs.loading()
            setTimeout(() => {
                if (me.periodoSelect == "" || me.periodoSelect == null || me.periodoSelect == undefined) {
                    me.m_message("Seleccione un periodo por favor", "warning")
                    me.$vs.loading.close()
                    return
                }
                me.periodo_id = me.periodoSelect.idperiodoescolar
                me.nombrePeriodo = me.periodoSelect.periodoescolar
                me.mostrar = true
                me.$vs.loading.close()
            }, 1000)
        },
        //metodo para exportar los registros de liquidaciones
        // Calcula la venta total
        getVenta(item) {
            // Verifica si 'verificaciones' es mayor a 0
            if (item.verificaciones > 0) {
                return item.TotalVentaReal.toFixed(2); // Si está liquidado, devuelve el valor real
            } else {
                // Si no está liquidado, suma 'total_venta' y los alcances (si existen)
                const ventaTotal = item.total_venta + (item.alcances ? item.alcances * 1 : 0);
                return ventaTotal.toFixed(2); // Devuelve el total con 2 decimales
            }
        },
        // Calcula la venta con el descuento aplicado
        getVentaDescuento(item) {
            const venta = this.getVenta(item);
            return (venta - (venta * item.descuento) / 100).toFixed(2);
        },
        getDescuento(item) {
            const venta = this.getVenta(item);
            return ((venta * item.descuento) / 100).toFixed(2);
        },
        getDeudaAnterior(item) {
            return (item.valor_deudaAnterior * 1).toFixed(2);
        },
        getConvenio(item) {
            return (item.valor_convenio * 1).toFixed(2);
        },
        getAnticipo(item) {
            return (item.valor_anticipos * 1).toFixed(2);
        },
        getLiquidaciones(item) {
            return (item.valor_liquidacion * 1).toFixed(2);
        },
        getVentaNeta(item) {
            const venta = this.getVenta(item);
            const convenio = this.getDescuento(item);
            return (venta * 1 - convenio * 1).toFixed(2);
        },
        // Calcula los anticipos o el convenio
        getAnticiposConvenio(item) {
            // Función auxiliar para asegurar que se redondeen y se devuelvan solo dos decimales
            function roundToTwoDecimalPlaces(value) {
                return parseFloat(value.toFixed(2));
            }

            // Convertimos los valores a números con dos decimales
            const valorConvenio = item.valor_convenio ? roundToTwoDecimalPlaces(item.valor_convenio) : 0;
            const valorAnticipos = item.valor_anticipos ? roundToTwoDecimalPlaces(item.valor_anticipos) : 0;
            const valorLiquidacion = item.valor_liquidacion ? roundToTwoDecimalPlaces(item.valor_liquidacion) : 0;
            const valortotalAnticiposLiquidacionOtrosValores = item.valortotalAnticiposLiquidacionOtrosValores ? roundToTwoDecimalPlaces(item.valortotalAnticiposLiquidacionOtrosValores) : 0;

            // Caso cuando los cuatro valores existen
            if (valorConvenio && valorAnticipos && valorLiquidacion) {
                // Comprobamos si hay variaciones entre los valores
                if (valorConvenio !== valorAnticipos || valorConvenio !== valorLiquidacion ||
                    valorAnticipos !== valorLiquidacion) {
                    return roundToTwoDecimalPlaces(valorConvenio + valorAnticipos + valorLiquidacion + valortotalAnticiposLiquidacionOtrosValores); // Sumar si hay variación
                }
                return roundToTwoDecimalPlaces(valorConvenio + valorAnticipos + valorLiquidacion + valortotalAnticiposLiquidacionOtrosValores); // Caso sin variaciones
            }

            // Caso cuando existen tres valores
            if ((valorConvenio && valorAnticipos && valorLiquidacion) ||
                (valorConvenio && valorAnticipos ) ||
                (valorConvenio && valorLiquidacion) ||
                (valorAnticipos && valorLiquidacion)) {
                return roundToTwoDecimalPlaces(valorConvenio + valorAnticipos + valorLiquidacion + valortotalAnticiposLiquidacionOtrosValores);
            }

            // Caso cuando existen dos valores y hay variación entre ellos
            if ((valorConvenio && valorAnticipos) ||
                (valorConvenio && valorLiquidacion) ||
                (valorConvenio) ||
                (valorAnticipos && valorLiquidacion) ||
                (valorAnticipos) ||
                (valorLiquidacion )) {
                return roundToTwoDecimalPlaces(valorConvenio + valorAnticipos + valorLiquidacion + valortotalAnticiposLiquidacionOtrosValores);
            }

            // Caso cuando solo existe un valor
            if (valorConvenio) return roundToTwoDecimalPlaces(valorConvenio);
            if (valorAnticipos) return roundToTwoDecimalPlaces(valorAnticipos);
            if (valorLiquidacion) return roundToTwoDecimalPlaces(valorLiquidacion);

            // Caso por defecto cuando ninguno de los valores existe
            return '0';
        },
        // Calcula el saldo pendiente
        getSaldoPendiente(item) {
            const ventaDescuento = this.getDescuento(item);
            const anticiposConvenio = this.getAnticiposConvenio(item);
            let preSaldoPendiente = (ventaDescuento - parseFloat(anticiposConvenio)).toFixed(2);
            // RESTAR preSaldoPendiente - DEUDA ANTERIOR
            item.valor_deudaAnterior = item.valor_deudaAnterior ? item.valor_deudaAnterior : 0;
            let saldoPendienteFinal = (preSaldoPendiente - parseFloat(item.valor_deudaAnterior)).toFixed(2);
            return saldoPendienteFinal;
        },
        // Obtiene la fecha de verificación según el número
        getVerificacionFecha(item, numVerificacion) {
            if (!item.arrayVerificaciones || !Array.isArray(item.arrayVerificaciones) || item.arrayVerificaciones.length === 0) {
                return '-';
            }
            const verificacion = item.arrayVerificaciones.find(v => v.num_verificacion === numVerificacion);
            if (verificacion && verificacion.fecha_fin) {
                return this.formatearFecha(verificacion.fecha_fin);
            }
            return '-';
        },
        // Formatea la fecha de YYYY-MM-DD a YYYY-MM-DD (mantiene formato original)
        formatearFecha(fecha) {
            if (!fecha) return '-';
            return fecha; // Retorna en formato YYYY-MM-DD
        },
        // Método para filtrar las liquidaciones por asesor
        filterByAsesor() {
            if (this.selectedAsesor) {
                this.filteredLiquidaciones = this.liquidaciones.filter(item => item.id_asesor === this.selectedAsesor);
            } else {
                this.filteredLiquidaciones = this.liquidaciones; // Si no hay filtro, mostrar todo
            }
        },
        // Método para obtener las liquidaciones y extraer la lista de asesores
        async verLiquidaciones() {
            try {

                if (this.ifExterno == 0) {
                    console.log("this.periodoSelect", this.periodoSelect);
                    if (this.periodoSelect == undefined || this.periodoSelect == null || this.periodoSelect == "") {
                        this.$vs.notify({
                            text: 'Debe seleccionar un período',
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                        return
                    }
                }

                this.$vs.loading();

                // Hacer la solicitud GET para obtener las liquidaciones
                const response = await this.$http.get(`${this.$server_url}get_liquidaciones?periodo=${this.periodoSelect.idperiodoescolar}&tipoVenta=2`);

                this.liquidaciones = response.data;
                this.filteredLiquidaciones = this.liquidaciones;

                // Extraer los asesores únicos de las liquidaciones
                this.asesores = [...new Set(this.liquidaciones.map(item => item.id_asesor))].map(id => {
                    const asesor = this.liquidaciones.find(item => item.id_asesor === id);
                    return {
                        id_asesor: asesor.id_asesor,
                        vendedor: asesor.vendedor
                    };
                });

                this.$vs.loading.close();
                this.popupLiquidaciones = true;
            } catch (error) {
                this.$vs.loading.close();
                console.error('Error al obtener las liquidaciones:', error);
            }
        },
        async ExportarLiquidaciones() {
            try {
                this.$vs.loading();
                let me = this;
                const periodo = this.periodoSelect.periodoescolar; // Obtener el periodo

                // Hacer la solicitud GET al backend para obtener los datos
                const response = await this.$http.get(this.$server_url + 'get_liquidaciones?periodo=' + me.periodoSelect.idperiodoescolar+'&tipoVenta=2');
                const liquidaciones = response.data; // Los datos de liquidaciones

                // Crear un libro de trabajo de Excel
                const wb = XLSX.utils.book_new();

                // Preparar los datos del reporte de liquidaciones
                const wsData = [];

                // Calcular el número máximo de verificaciones
                const maxVerif = Math.max(...liquidaciones.map(item => {
                    if (item.arrayVerificaciones && Array.isArray(item.arrayVerificaciones)) {
                        return item.arrayVerificaciones.length;
                    }
                    return 0;
                }), 0);

                // Crear encabezados dinámicos para verificaciones
                const verificacionHeaders = [];
                for (let i = 1; i <= maxVerif; i++) {
                    verificacionHeaders.push(`Verificación ${i}`);
                }

                // Agregar título y encabezados al reporte
                wsData.push(["Reporte de Liquidaciones"]); // Título
                wsData.push([`Periodo: ${periodo}`]); // Información adicional del periodo
                wsData.push([]); // Espacio vacío
                wsData.push([
                    '# Pedido', 'Contrato Generado', 'Institución', 'Vendedor',
                    'Venta Bruta', 'Estado', 'Descuento', 'Comisión', 'Venta Neta',
                    'Deuda Anterior', 'Convenio', 'Anticipos',
                    'Liquidaciones', 'Pagos', 'Saldo Pendiente', ...verificacionHeaders
                ]); // Encabezado de la tabla

                // Agregar los datos de liquidaciones
                let totalVentaTotal = 0;
                let totalVentaReal = 0;
                let totalComision = 0;
                let totalAnticiposConvenio = 0;
                let totalSaldoPendiente = 0;
                let totalDeuda = 0;
                let totalConvenio = 0;
                let totalAnticipos = 0;
                let totalLiquidaciones = 0;
                let totalVentaNeta = 0;
                liquidaciones.forEach(item => {
                    const ventaTotal = Number(this.getVenta(item)) || 0; // Convertir a número
                    const descuento = item.descuento || 0;
                    const comision = Number(this.getDescuento(item)) || 0; // Convertir a número
                    const anticiposConvenio = Number(this.getAnticiposConvenio(item)) || 0; // Convertir a número
                    const saldoPendiente = Number(this.getSaldoPendiente(item)) || 0; // Convertir a número
                    const deuda = Number(this.getDeudaAnterior(item)) || 0; // Convertir a número
                    const estado = item.estadoPedido_Pagos == 4 ? 'LIQUIDADO SIN CÓDIGOS' : (item.verificaciones > 0 ? 'LIQUIDADO' : 'SIN LIQUIDAR');
                    const convenio = Number(this.getConvenio(item)) || 0; // Convertir a número
                    const anticipos = Number(this.getAnticipo(item)) || 0; // Convertir a número
                    const liquidaciones = Number(this.getLiquidaciones(item)) || 0; // Convertir a número
                    const ventaNeta = Number(this.getVentaNeta(item)) || 0;

                    const ventaReal = Number(item.TotalVentaReal) || 0; // Accediendo directamente a TotalVentaReal

                    // Generar las fechas de verificación dinámicamente
                    const verificacionesFechas = [];
                    for (let i = 1; i <= maxVerif; i++) {
                        verificacionesFechas.push(this.getVerificacionFecha(item, i));
                    }

                    // Agregar los valores a la hoja de Excel
                    wsData.push([
                        item.id_pedido,
                        item.contrato_generado,
                        item.nombreInstitucion,
                        item.vendedor,
                        ventaTotal.toFixed(2) * 1,
                        estado,
                        `${descuento} %`,
                        comision.toFixed(2) * 1,
                        ventaNeta.toFixed(2) * 1,
                        deuda.toFixed(2) * 1,
                        convenio.toFixed(2) * 1,
                        anticipos.toFixed(2) * 1,
                        liquidaciones.toFixed(2) * 1,
                        anticiposConvenio.toFixed(2) * 1,
                        saldoPendiente.toFixed(2) * 1,
                        ...verificacionesFechas
                    ]);

                    // Sumar los totales
                    totalVentaTotal += ventaTotal;
                    totalVentaReal += ventaReal;
                    totalComision += comision;
                    totalAnticiposConvenio += anticiposConvenio;
                    totalSaldoPendiente += saldoPendiente;
                    totalDeuda += deuda;
                    totalConvenio += convenio;
                    totalAnticipos += anticipos;
                    totalLiquidaciones += liquidaciones;
                    totalVentaNeta += ventaNeta
                });
                // Agregar los totales al final de la hoja de liquidaciones
                wsData.push(['', '', '', 'Totales:',
                    totalVentaTotal.toFixed(2),
                    '', '',
                    totalComision.toFixed(2),
                    totalVentaNeta.toFixed(2),
                    totalDeuda.toFixed(2),
                    totalConvenio.toFixed(2),
                    totalAnticipos.toFixed(2),
                    totalLiquidaciones.toFixed(2),
                    totalAnticiposConvenio.toFixed(2),
                    totalSaldoPendiente.toFixed(2)
                ]);

                // Crear la hoja de liquidaciones
                const ws = XLSX.utils.aoa_to_sheet(wsData);

                // Agregar la hoja de liquidaciones al libro de trabajo
                XLSX.utils.book_append_sheet(wb, ws, 'Liquidaciones');

                // Crear la hoja de liquidaciones por asesor
                const wsAsesoresData = [];
                wsAsesoresData.push(["Liquidaciones por Asesor"]); // Título de la nueva hoja
                wsAsesoresData.push([`Periodo: ${periodo}`]); // Información adicional del periodo
                wsAsesoresData.push([]); // Espacio vacío

                // Agregar el encabezado para la hoja de asesores
                wsAsesoresData.push([
                    'Asesor', 'Venta Total', 'Comisión Total', 'Deuda Anterior Total', 'Convenio Total', 'Anticipos Total',
                    'Total Liquidaciones', 'Pagos Total', 'Saldo Pendiente Total'
                ]);

                // Crear un objeto para almacenar las sumas por asesor
                const resumenAsesores = {};

                liquidaciones.forEach(item => {
                    const asesor = item.vendedor;
                    const ventaTotal = Number(this.getVenta(item)) || 0; // Convertir a número
                    const comision = Number(this.getDescuento(item)) || 0; // Comisión
                    const anticiposConvenio = Number(this.getAnticiposConvenio(item)) || 0; // Anticipos/Convenio
                    const deuda = Number(this.getDeudaAnterior(item)) || 0; // Deuda anterior
                    const convenio = Number(this.getConvenio(item)) || 0; // Convenio
                    const anticipo = Number(this.getAnticipo(item)) || 0; // Anticipo
                    const liquidaciones = Number(this.getLiquidaciones(item)) || 0; // Liquidaciones
                    const saldoPendiente = Number(this.getSaldoPendiente(item)) || 0; // Saldo Pendiente

                    // Inicializar el objeto del asesor si no existe
                    if (!resumenAsesores[asesor]) {
                        resumenAsesores[asesor] = {
                            ventaTotal: 0,
                            comisionTotal: 0,
                            anticiposConvenioTotal: 0,
                            deudaAnteriorTotal: 0,
                            convenioTotal: 0,
                            anticipoTotal: 0,
                            liquidacionesTotal: 0,
                            saldoPendienteTotal: 0,
                        };
                    }

                    // Sumar los valores (sin importar el estado de liquidación)
                    resumenAsesores[asesor].ventaTotal += ventaTotal;
                    resumenAsesores[asesor].comisionTotal += comision;
                    resumenAsesores[asesor].deudaAnteriorTotal += deuda;
                    resumenAsesores[asesor].convenioTotal += convenio;
                    resumenAsesores[asesor].anticipoTotal += anticipo;
                    resumenAsesores[asesor].liquidacionesTotal += liquidaciones;
                    resumenAsesores[asesor].anticiposConvenioTotal += anticiposConvenio;
                    resumenAsesores[asesor].saldoPendienteTotal += saldoPendiente;
                });

                // Agregar las filas por asesor (todo sumado en un solo total)
                Object.keys(resumenAsesores).forEach(asesorId => {
                    const asesor = resumenAsesores[asesorId];

                    wsAsesoresData.push([
                        asesorId,
                        asesor.ventaTotal.toFixed(2), // Venta total
                        asesor.comisionTotal.toFixed(2), // Comisión total (si no es 0)
                        asesor.deudaAnteriorTotal.toFixed(2), // Deuda anterior total (si no es 0)
                        asesor.convenioTotal.toFixed(2), // Anticipos/Convenio total (si no es 0)
                        asesor.anticipoTotal.toFixed(2), // Anticipos total (si no es 0)
                        asesor.liquidacionesTotal.toFixed(2), // Liquidaciones total (si no es 0)
                        asesor.anticiposConvenioTotal.toFixed(2), // Saldo pendiente total (si no es 0)
                        asesor.saldoPendienteTotal.toFixed(2), // Saldo pendiente total
                    ]);
                });

                // Crear la hoja del libro con los datos de los asesores
                const wsAsesores = XLSX.utils.aoa_to_sheet(wsAsesoresData);

                // Agregar la hoja de liquidaciones por asesor al libro de trabajo
                XLSX.utils.book_append_sheet(wb, wsAsesores, 'Liquidaciones por Asesor');

                // Exportar el archivo Excel
                XLSX.writeFile(wb, `Liquidaciones_${periodo}.xlsx`);
                this.$vs.loading.close();
            } catch (error) {
                this.$vs.loading.close();
                console.error('Error al exportar liquidaciones:', error);
            }
        },
    }
}
</script>

<style scoped>
.total-item {
    background-color: #f9f9f9;
    padding: 10px;
    margin: 10px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Estilo para el filtro de asesor */
.filter-container {
    margin-bottom: 1rem;
    padding: 10px;
    background-color: #f4f4f4;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Responsividad para pantallas pequeñas */
@media (max-width: 768px) {
    .total-item {
        flex: 1 1 100%;
    }

    .totals-row {
        flex-direction: column;
    }
}
</style>
